import React from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { handleEmailPasswordSignUp, openEmailLoginDialog } from "../auth/AuthActions";

const SignUpDialog = ({ name, setName, email, setEmail, password, setPassword, onSubmit }) => {
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && onSubmit) {
      e.preventDefault();
      onSubmit();
    }
  };

  return (
    <div className="space-y-4 py-2">
      <p className="text-sm text-gray-600">
        Create an account to apply for dataset access and manage your AIRCHECK profile.
      </p>
      <div className="flex flex-col gap-1">
        <label htmlFor="name" className="text-sm font-medium text-gray-700">
          Full name
        </label>
        <InputText
          id="name"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Jane Doe"
          className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div className="flex flex-col gap-1">
        <label htmlFor="email" className="text-sm font-medium text-gray-700">
          Email address
        </label>
        <InputText
          id="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="you@example.com"
          className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div className="flex flex-col gap-1">
        <label htmlFor="password" className="text-sm font-medium text-gray-700">
          Password
        </label>
        <InputText
          id="password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="At least 8 characters"
          className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <span className="text-xs text-gray-500">
          Use 8 or more characters with a mix of letters, numbers, and symbols.
        </span>
      </div>
    </div>
  );
};

const SignUpDialogFooter = ({
  name,
  email,
  password,
  signUpWithEmailPassword,
  setShowSignUpDialog,
  setNotificationMessage,
  setShowNotification,
  setIsError,
  setShowLoginChoiceDialog,
  setShowLoginDialog,
  setShowResetPasswordDialog,
}) => {
  const submit = () =>
    handleEmailPasswordSignUp(
      name,
      email,
      password,
      signUpWithEmailPassword,
      setShowSignUpDialog,
      setNotificationMessage,
      setShowNotification,
      setIsError,
    );

  return (
    <div className="flex flex-col gap-3 pt-2">
      <div className="flex justify-end gap-2">
        <Button
          label="Back to Sign In"
          onClick={() =>
            openEmailLoginDialog(
              setShowLoginChoiceDialog,
              setShowSignUpDialog,
              setShowLoginDialog,
              setShowResetPasswordDialog,
            )
          }
          className="rounded-md shadow-sm px-5 py-2 bg-red-500 text-white hover:bg-red-700 transition duration-200"
        />
        <Button
          label="Create Account"
          onClick={submit}
          className="rounded-md shadow-sm px-5 py-2 bg-green-500 text-white hover:bg-green-700 transition duration-200"
        />
      </div>
      <p className="text-xs text-gray-500 text-right">
        By creating an account you agree to receive verification emails from AIRCHECK.
      </p>
    </div>
  );
};

export { SignUpDialog, SignUpDialogFooter };
